import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { createContext } from 'react'
import { ProgressProps, UserContent, UserProfileResponse } from './types'
import { initialUserProfileState } from './variables'

export const UserProfileContext = createContext<{
  loading: boolean
  progressItems: ProgressProps
  setUserContentState: (value: React.SetStateAction<UserContent>) => void
  userContentState: UserContent
  updateProgressItem: (name: keyof ProgressProps) => void
  refetchUserProfile: (
    variables?: Partial<OperationVariables>
  ) => Promise<ApolloQueryResult<UserProfileResponse>>
}>({
  userContentState: initialUserProfileState.currentUserData[0],
  loading: false,
  setUserContentState: () => null,
  progressItems:
    initialUserProfileState.currentUserData[0].profile.profileCompletion,
  refetchUserProfile: () => null,
  updateProgressItem: () => null,
})
